// Product cards (owner 26.10.2026): hovering a fabric swatch under the card shows that variant – its picture, its name in
// place of the card's variant name, and the card's links lead to it. Moving off the swatches brings the card back.
// Swatches come from snippets/card-product.liquid (.product-card__swatch with data-image / data-title / data-url).
(() => {
  if (window.productCardSwatches) return;
  window.productCardSwatches = true;

  const css = document.createElement('style');
  css.textContent = '.product-card__swatch{display:flex}' +
    '.product-card__swatch.is-active .swatch{outline:1px solid var(--color-outline-gray-hover);outline-offset:3px}' +
    // the card's own hover picture (3rd photo) stays hidden while a swatch is previewed
    '.product-card.is-swatch-preview .product-card__image{opacity:1}' +
    '.product-card.is-swatch-preview .product-card__hover-image{opacity:0}';
  document.head.append(css);

  let active = null;   // the card being previewed and what it showed before

  function restore() {
    if (!active) return;
    const a = active;
    active = null;
    a.card.classList.remove('is-swatch-preview');
    if (a.swatch) a.swatch.classList.remove('is-active');
    if (a.img) {
      a.img.setAttribute('src', a.src);
      if (a.srcset) a.img.setAttribute('srcset', a.srcset);
    }
    if (a.name) a.name.textContent = a.text;
    a.links.forEach(([link, href]) => link.setAttribute('href', href));
  }

  function preview(swatch) {
    const card = swatch.closest('.product-card');
    if (!card) return;
    if (active && active.card !== card) restore();
    if (!active) {
      const img = card.querySelector('.product-card__image');
      const name = card.querySelector('.product-card__variant-name');
      active = {
        card, img, name,
        src: img && img.getAttribute('src'),
        srcset: img && img.getAttribute('srcset'),
        text: name && name.textContent,
        links: [...card.querySelectorAll('a.product-card__media__inner, a.product-card__content')].map(a => [a, a.getAttribute('href')])
      };
    }
    if (active.swatch) active.swatch.classList.remove('is-active');
    active.swatch = swatch;
    swatch.classList.add('is-active');
    card.classList.add('is-swatch-preview');
    const { image, title, url } = swatch.dataset;
    if (image && active.img) {
      active.img.removeAttribute('srcset');
      active.img.setAttribute('src', image);
    } else if (active.img) {
      active.img.setAttribute('src', active.src);
      if (active.srcset) active.img.setAttribute('srcset', active.srcset);
    }
    if (title && active.name) active.name.textContent = title;
    if (url) active.links.forEach(([link]) => link.setAttribute('href', url));
  }

  // the variants' pictures load when the pointer first reaches a card's swatches, so the preview is instant
  function preload(swatches) {
    if (swatches.dataset.preloaded) return;
    swatches.dataset.preloaded = '1';
    swatches.querySelectorAll('.product-card__swatch[data-image]').forEach(el => {
      if (el.dataset.image) new Image().src = el.dataset.image;
    });
  }

  document.addEventListener('mouseover', event => {
    const target = event.target instanceof Element ? event.target : null;
    const swatches = target && target.closest('.product-card__swatches');
    if (swatches) preload(swatches);
    const swatch = target && target.closest('.product-card__swatch');
    if (swatch) return preview(swatch);
    // between two swatches the preview stays; anywhere else the card goes back
    if (active && !(swatches && active.card.contains(swatches))) restore();
  });
})();
